import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { type IAlert } from "@/interfaces/component/alert.interface"

export const useToastStore = defineStore("toastStore", () => {
  const pendingToasts: Ref<IAlert[]> = ref([])

  function addToast(toast: IAlert) {
    pendingToasts.value = [...pendingToasts.value, { ...toast }]
  }

  // Buffer notifications from non-component callers until ToastViewer can pass them forward.
  function takeToasts() {
    const notifications = pendingToasts.value
    pendingToasts.value = []
    return notifications
  }

  return {
    pendingToasts,
    addToast,
    takeToasts
  }
})
